export default "__VITE_ASSET__DItkGO6e__"